<template lang="pug">
.numeric-input(:class="{ 'is-invalid': hasError }")
    font-awesome-icon.form-control-icon(icon="square-root-alt", v-if="allowMath")
    input.form-control(v-model.lazy="localValue", :class="{ 'is-invalid': hasError }")
    small.form-text.invalid-feedback Keine valide Zahl oder unterstützter mathematischer Ausdruck - bitte prüfen Sie Ihre Eingabe
    small.form-text.text-muted(v-if="allowMath && !hasError") In diesem Eingabefeld können Sie mathematische Ausdrücke mit #[code +], #[code -], #[code *], #[code /] verwenden.
</template>

<script>
import exactMath from 'exact-math'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSquareRootAlt } from '@fortawesome/free-solid-svg-icons'

library.add(faSquareRootAlt)

export default {
    props: {
        value: {
            type: [Number, String],
            default: null
        },
        allowMath: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            hasError: false
        }
    },
    emits: ['input'],
    computed: {
        localValue: {
            get () {
                return this.value
            },
            set (value) {
                let result

                this.hasError = false

                if (this.allowMath) {
                    // if math is allowed - parse formula (returns NaN if invalid)
                    result = exactMath.formula(value, {
                        invalidError: false
                    })
                } else {
                    // at least replace comma-decimal-separator with a dot
                    result = value.replace(/,/g, '.').replace(/[^0-9.]/, '')
                }

                // invalid input?
                if (isNaN(result)) {
                    this.hasError = true
                    this.$emit('input', value)
                    return
                }

                this.$emit('input', result)
            }
        }
    },
    methods: {
        resetError () {
            this.hasError = false
        }
    }
}
</script>

<style scoped>
.numeric-input {
    position: relative;
    width: 100%;
}

.form-control-icon {
    position: absolute;
    z-index: 2;
    display: block;
    text-align: center;
    pointer-events: none;
    color: #ccc;
    right: 0.7rem;
    margin-top: 0.7rem;
}

.numeric-input.is-invalid .form-control-icon {
    display: none;
}

.form-control-icon + .form-control {
    padding-right: 2rem;
}
</style>
